module.exports = __webpack_public_path__ + "img/header.69656f68.png";